import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState } from './emptyState';
import { RunningState } from './runningState';
import { useListAgent } from './hooks/useListAgent';
import { GrowListAgentModal } from './growListAgent';

export const AiAgent = ({ sharedList }) => {
  const {
    isCreatingCampaign,
    hasAgent,
    agentCampaign,
    availableCredits,
    handleSetupAgent,
    handleOpenAgent,
    isGrowListAgentOpen,
    handleCloseGrowListAgent,
    createdCampaign,
  } = useListAgent({
    sharedList,
  });

  return (
    <>
      {!hasAgent && (
        <EmptyState
          availableCredits={availableCredits}
          onSetupAgent={handleSetupAgent}
          isLoading={isCreatingCampaign}
        />
      )}
      {hasAgent && <RunningState campaign={agentCampaign} onOpenAgent={handleOpenAgent} />}

      {isGrowListAgentOpen && (
        <GrowListAgentModal
          isOpen={isGrowListAgentOpen}
          onClose={handleCloseGrowListAgent}
          sharedList={sharedList}
          campaign={createdCampaign}
        />
      )}
    </>
  );
};

AiAgent.propTypes = {
  sharedList: PropTypes.object.isRequired,
};
